export class ReceivableSummary {
    /** Unique internal identity of the coporation, dealer or lot based on the grouping associated with the receivable. */
    public companyId: number = 0;
    
    /** Name of the corporation, dealer or lot based on the grouping associated with this receivable. */
    public company: string;

    /** */
    public address: string;

    /** */
    public cityStateZip: string;

    /** The maximum receivable day for those included in this summary. */
    public asOf: Date;

    /** Total number of accounts. */
    public count: number = 0;

    /** Total number of true daily earnings accounts. */
    public tdeCount: number = 0;

    /** Total number of schedled installment earnings accounts. */
    public sieCount: number = 0;

    /** Total number of monthly payment frequency accounts. */
    public monthlyCount: number = 0;

    /** Total number of semi-monthly payment frequency accounts. */
    public semiMonthlyCount: number = 0;

    /** Total number of bi-weekly payment frequency accounts. */
    public biWeeklyCount: number = 0;

    /** Total number of weekly payment frequency accounts. */
    public weeklyCount: number = 0;
    
    /** Average annual percentage rate from the installment sale contract. */
    public apr: number = 0;
    
    /** The average weekly payment for the grouped accounts.. */
    public avgWeeklyayment: number = 0;

    /** The total amount due from all categories of possible payments. */
    public amount: number = 0;
    
    /** The total amount due for the mv loan or drive out price. */
    public loan: number = 0;
    
    /** The total amount due for the deposit, if any. */
    public deposit: number = 0;
    
    /** The total amount due for the initial down payment, if any. */
    public initial: number = 0;
    
    /** The total amount due for the deferred down payment(s), if any. */
    public deferred: number = 0;
    
    /** Total total of unpaid deferred down payments. */
    public unpaidDeferred: number = 0;
    
    /** The total amount due for the cpi (insurance), if any.  */
    public cpi: number = 0;
    
    /** The total amount due for the late fees, if any.  */
    public lateFees: number = 0;
    
    /** The total amount of any unpaid items for all loans. */
    public payoff: number = 0;
    
    /** The total princiapl balance of all loan. */
    public balance: number = 0;
    
    /** The total tax balance of all loans, if any. */
    public taxBalance: number = 0;
    
    /** The total amount of any unpaid payments. */
    public paymentBalance: number = 0;
    
    /** Total amount of any earned unpaid interest. */
    public unpaidEarnedInterest: number = 0;
    
    /** Computed amount of any potential unearned interest for the rest of the loan life (SIE). */
    public unearnedInterest: number = 0;
    
    /** Total amount the coporation (lot/dealer) must collect before a break-even point is crossed. */
    public ridingCash: number = 0;

    /** Total number of accounts that are not past due. */
    public current: number = 0;

    /** Total payment amount of accounts that are not past due. */
    public currentAmt: number = 0;

    /** Total principal balance of accounts that are not past due. */
    public currentBalance: number = 0;

    /** Total principal + tax balance of accounts that are not past due. */
    public currentWithTaxBalance: number = 0;

    /** Total payment balance of accounts that are not past due. */
    public currentPaymentBalance: number = 0;

    /** Total payoff of accounts that are not past due. */
    public currentPayoff: number = 0;
    
    /** Total number of accounts that are not past due. */
    public late: number = 0;

    /** Total payment amount of accounts that are not past due. */
    public lateAmt: number = 0;

    /** Total principal balance of accounts that are not past due. */
    public lateBalance: number = 0;

    /** Total number of accounts that are 1-15 days past due. */
    public late1To15: number = 0;

    /** Total payment amount of accounts that are 1-15 days past due. */
    public late1To15Amt: number = 0;

    /** Total principal balance of accounts that are 1-15 days past due. */
    public late1To15Balance: number = 0;

    /** Total number of accounts that are 16-30 days past due. */
    public late16To30: number = 0;

    /** Total payment amount of accounts that are 16-30 days past due. */
    public late16To30Amt: number = 0;

    /** Total principal balance of accounts that are 16-30 days past due. */
    public late16To30Balance: number = 0;

    /** Total number of accounts that are 31-60 days past due. */
    public late31To60: number = 0;

    /** Total payment amount of accounts that are 31-60 days past due. */
    public late31To60Amt: number = 0;

    /** Total principal balance of accounts that are 31-60 days past due. */
    public late31To60Balance: number = 0;

    /** Total number of accounts that are 61-90 days past due. */
    public late61To90: number = 0;

    /** Total payment amount of accounts that are 61-90 days past due. */
    public late61To90Amt: number = 0;

    /** Total principal balance of accounts that are 61-90 days past due. */
    public late61To90Balance: number = 0;

    /** Total number of accounts that are 91 and above days past due. */
    public late91AndOver: number = 0;

    /** Total payment amount of accounts that are 91 and above days past due. */
    public late91AndOverAmt: number = 0;

    /** Total principal balance of accounts that are 91 and above days past due. */
    public late91AndOverBalance: number = 0;

    /** Total number of accounts aged (past due) from 30 to 59 days. */
    public thirtyDay: number = 0;

    /** Total principal balance of accounts aged (past due) from 30 to 59 days. */
    public thirtyDayBalance: number = 0;

    /** Total principal + tax balance of accounts aged (past due) from 30 to 59 days. */
    public thirtyDayWithTaxBalance: number = 0;

    /** Total payment balance of accounts aged (past due) from 30 to 59 days. */
    public thirtyDayPaymentBalance: number = 0;

    /** Total payoff of accounts aged (past due) from 30 to 59 days. */
    public thirtyDayPayoff: number = 0;

    /** Total number of accounts aged (past due) from 60 to 89 days. */
    public sixtyDay: number = 0;

    /** Total principal balance of accounts aged (past due) from 60 to 89 days. */
    public sixtyDayBalance: number = 0;

    /** Total principal + tax balance of accounts aged (past due) from 60 to 89 days. */
    public sixtyDayWithTaxBalance: number = 0;

    /** Total payment balance of accounts aged (past due) from 60 to 89 days. */
    public sixtyDayPaymentBalance: number = 0;

    /** Total payoff of accounts aged (past due) from 60 to 89 days. */
    public sixtyDayPayoff: number = 0;

    /** Total number of accounts aged (past due) 90 days or more. */
    public ninetyDay: number = 0;

    /** Total principal balance of accounts aged (past due) 90 days or more. */
    public ninetyDayBalance: number = 0;

    /** Total principal + tax balance of accounts aged (past due) 90 days or more. */
    public ninetyDayWithTaxBalance: number = 0;

    /** Total payment balance of accounts aged (past due) 90 days or more. */
    public ninetyDayPaymentBalance: number = 0;

    /** Total payoff of accounts aged (past due) 90 days or more. */
    public ninetyDayPayoff: number = 0;
}